import { Formatter } from "../../../utils/formatter"

export default class Currency {
    constructor(public value = 0) {}

    public getValueFormatted (): string {
        return Formatter.formatNumberToBRCurrency(this.value)
    }
}